import { render, staticRenderFns } from "./VoidPengembalian.vue?vue&type=template&id=28988490&scoped=true&"
import script from "./VoidPengembalian.vue?vue&type=script&lang=js&"
export * from "./VoidPengembalian.vue?vue&type=script&lang=js&"
import style0 from "./VoidPengembalian.vue?vue&type=style&index=0&id=28988490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28988490",
  null
  
)

export default component.exports